import React from 'react';
import { CircularProgress } from '@mui/material';

interface LoadingIndicatorProps {
  isLoading: boolean;
  message?: string;
}

const LoadingIndicator = ({ isLoading, message }: LoadingIndicatorProps) => {
  if (isLoading) {
    return (
      <div
        style={{
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          height: '60vh',
          width: '100vw',
        }}>
        <CircularProgress />
        {message && <p style={{ marginTop: '0.75em' }}>{message}</p>}
      </div>
    );
  }

  return null;
};

export default LoadingIndicator;
